<template>
  <b-container>
    <h2>{{ $t("fuelConsumptionTarget.title") }}</h2>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row>
      <router-link to="././create">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
      <b-button
        size="sm"
        class="ml-2 btn-checklist cleanFilters"
        @click="cleanFilters"
      >
        {{ $t("geral.cleanFilters") }}
      </b-button>
      <b-button
        size="sm"
        class="ml-2 btn-checklist cleanFilters"
        @click="$refs.table.refresh()"
      >
        <i
          class="material-icons"
          style="font-size: 18px; vertical-align: middle; margin-right: 5px"
        >
          refresh
        </i>
        {{ $t("geral.refresh") }}
      </b-button>
      <!-- <b-col cols="0" class="ml-2">
        <router-link to="././import">
          <b-button size="sm">
            {{ $t("geral.import") }}
          </b-button>
        </router-link>
      </b-col>
      <b-col cols="0" class="ml-2">
        <b-button size="sm" @click="downloadLayout">
          {{ $t("geral.importLayout") }}
        </b-button>
      </b-col> -->
    </b-row>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="tableFilters[field.key] != null">
                <div v-if="field.filterType == 'date'">
                  <b-form-input type="date" v-model="tableFilters[field.key]" />
                </div>
                <div v-else-if="field.filterType == 'double'">
                  <b-form-input type="text" v-model="tableFilters[field.key]" />
                </div>
                <div v-else-if="field.filterKey != 'actions'">
                  <b-form-input
                    v-model="tableFilters[field.filterKey]"
                    :placeholder="'Buscar por ' + field.label"
                    class="idStyle"
                  />
                </div>
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <router-link :to="`././edit/${data.item.id}`">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <b-button
            v-if="data.item.active"
            style="margin-left: 5px;"
            size="sm"
            class="btn-checklist ml-2"
            @click="inactivateTarget(data.item.id)"
            :disabled="isLoading"
          >
            Desativar
          </b-button>
          <b-button
            v-else
            style="margin-left: 5px;"
            size="sm"
            class="btn-checklist ml-2"
            @click="activateTarget(data.item.id)"
            :disabled="isLoading"
          >
            Ativar
          </b-button>
        </template>
      </b-table>
    </b-row>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>

<script>
export default {
  name: "GasStationList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Posto de gasolina cadastrado com sucesso"
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "beginAt",
          filterKey: "beginAt",
          filterType: "date",
          label: "Data início",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "weightBegin",
          filterKey: "weightBegin",
          filterType: "double",
          label: "Peso inicial",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "weightEnd",
          filterKey: "weightEnd",
          filterType: "double",
          label: "Peso fim",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "consumptionTarget",
          filterKey: "consumptionTarget",
          filterType: "double",
          label: "Meta",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "vehicleModel",
          filterKey: "vehicleModel",
          label: "Modelo",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "vehicle",
          filterKey: "vehicle",
          label: "Veículo",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "fuelSupplyChecklistId",
          filterKey: "fuelSupplyChecklistId",
          label: "Checklist Destino",
          tdClass: "table-col-dinamic-width"
        }
      ],
      tableFilters: {
        vehicleModel: "",
        vehicle: "",
        beginAt: "",
        endAt: "",
        weightBegin: "",
        weightEnd: "",
        consumptionTarget: "",
        originChecklistId: "",
        fuelSupplyChecklistId: ""
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      isLoading: false
    };
  },
  created() {},
  methods: {
    cleanFilters() {
      this.tableFilters = {
        vehicleModel: "",
        vehicle: "",
        beginAt: "",
        endAt: "",
        weightBegin: "",
        weightEnd: "",
        consumptionTarget: "",
        originChecklistId: "",
        fuelSupplyChecklistId: ""
      };
    },
    updateTableMethod() {
      this.$refs.table.refresh();
    },
    getUrlEdit(vehicle) {
      return `././edit/${vehicle.id}`;
    },
    downloadLayout() {
      this.$apiVehicle
        .request({
          url: `/vehicle/import/download/`,
          method: "GET",
          responseType: "arraybuffer" //important
        })
        .then(response => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"]
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$refs.openModal.hide();
        });
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        vehicleModel: this.tableFilters.vehicleModel,
        vehicle: this.tableFilters.vehicle,
        beginAt: this.tableFilters.beginAt,
        endAt: this.tableFilters.endAt,
        weightBegin: this.tableFilters.weightBegin,
        weightEnd: this.tableFilters.weightEnd,
        consumptionTarget: this.tableFilters.consumptionTarget,
        originChecklistId: this.tableFilters.originChecklistId,
        fuelSupplyChecklistId: this.tableFilters.fuelSupplyChecklistId
      };
      console.log("apiParam", apiParam);
      this.$apiVehicle
        .post("/fuelConsumptionTarget/paginate/", apiParam)
        .then(response => {
          const items = response.data.items;
          // console.log = ("ok")
          // console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    inactivateTarget(targetId) {
      this.isLoading = true;
      console.log(`Inativando Meta com ID: ${targetId}`);
      this.$apiVehicle
        .post(`/fuelConsumptionTarget/deactivate/${targetId}`)
        .then(response => {
          console.log(response.data);
          this.alert.success = "Meta inativada com sucesso!";
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error);
          this.alert.error = error.message;
          this.$refs.danger.show();
        })
        .finally(() => {
          this.isLoading = false;
          this.$refs.table.refresh();
        });
    },
    activateTarget(targetId) {
      this.isLoading = true;
      console.log(`Ativando Meta com ID: ${targetId}`);
      this.$apiVehicle
        .post(`/fuelConsumptionTarget/activate/${targetId}`)
        .then(response => {
          console.log(response.data);
          this.alert.success = "Meta ativada com sucesso!";
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error);
          this.alert.error = error.message;
          this.$refs.danger.show();
        })
        .finally(() => {
          this.isLoading = false;
          this.$refs.table.refresh();
        });
    }
  }
};
</script>
